import { lazyLoad } from 'utils/loadable';

export const AutomationDefinitionPage = lazyLoad(
    () => import('./index'),
    module => module.AutomationDefinitionPage,
);